import { appColors } from '../config/theme'

/**
 * Color utility functions
 */

/**
 * Convert hex color to rgba with specified opacity
 */
export const hexToRgba = (hex: string, opacity: number): string => {
  const cleanHex = hex.replace('#', '')
  const r = parseInt(cleanHex.substr(0, 2), 16)
  const g = parseInt(cleanHex.substr(2, 2), 16)
  const b = parseInt(cleanHex.substr(4, 2), 16)
  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

/**
 * Get approval status color from theme
 */
export const getApprovalStatusColor = (status: string | undefined): string => {
  switch (status?.toUpperCase()) {
    case 'APPROVED':
      return appColors.success
    case 'REJECTED':
      return appColors.danger
    case 'PENDING':
    default:
      return appColors.warning
  }
}

/**
 * Get sacrament-related color
 */
export const getSacramentColor = (opacity: number = 1): string => {
  if (opacity === 1) {
    return appColors.sacrament
  }
  return hexToRgba(appColors.sacrament, opacity)
}

/**
 * Get church-related color
 */
export const getChurchColor = (opacity: number = 1): string => {
  if (opacity === 1) {
    return appColors.church
  }
  return hexToRgba(appColors.church, opacity)
}

/**
 * Gets status colors from the centralized theme
 */
export const getStatusColor = (status: 'success' | 'warning' | 'danger' | 'info'): string => {
  switch (status) {
    case 'success':
      return appColors.success
    case 'warning':
      return appColors.warning
    case 'danger':
      return appColors.danger
    case 'info':
      return appColors.info
    default:
      return appColors.primary
  }
}

/**
 * Get brand color with optional opacity
 */
export const getBrandColor = (opacity: number = 1): string => {
  if (opacity === 1) {
    return appColors.brand
  }
  return hexToRgba(appColors.brand, opacity)
}
